export default __webpack_public_path__ + "static/media/G & A Expense.5d365b12.png";